import React, { Component } from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import { Row, Card, Button, Col, Pagination,Badge } from 'react-bootstrap';
import _ from 'lodash'
import { userApi } from "../../../api"; /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
import  '../../Styles/css/w3.css'; /*Comments: Card style, Added By: <Asar>, Create Date: <2020-02-06>*/


class VideosGridContainer extends Component {
    static propTypes = {
        title: PropTypes.string,
        bmos: PropTypes.array,
        lbls: PropTypes.array, /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
        partners:PropTypes.array,       //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        bmospartners:PropTypes.array,   //added for partners filter in Resource page     /*Separate Partners from Operators Filter*/
        bridge:PropTypes.array,         //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        industries: PropTypes.array,
        years: PropTypes.bool,
        months: PropTypes.bool,
        bmos_enable:PropTypes.bool,     //added to show bmos enable check in Resource page  /*Separate Partners from Operators Filter*/
        partners_enable:PropTypes.bool, //added tp partners enable check in Resource page   /*Separate Partners from Operators Filter*/
        bridge_enable:PropTypes.bool,   //added to bridge enable check in Resource page     /*Separate Partners from Operators Filter*/
        data: PropTypes.array,
        selectedData: PropTypes.object,
        onChange: PropTypes.func,
        currentpage: PropTypes.number,
        max_num_pages: PropTypes.number,
        isLoading:PropTypes.bool,
        onPageChange:PropTypes.func,
        multiple_posttype:PropTypes.bool,
    };
    static defaultProps = {
        title: "",
        bmos: null,
        lbls: null, /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
        partners:null,          //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        bmos_partners:null,     //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        bridge: null,           //added for partners filter in Resource page    *Separate Partners from Operators Filter*/
        industries: null,
        years: false,
        months: false,
        bmos_enable: false,      //added for filter in Resource page   /*Separate Partners from Operators Filter*/
        partners_enable: false,  //added for filter in Resource page  /*Separate Partners from Operators Filter*/
        bridge_enable: false,    //added for filter in Resource page   /*Separate Partners from Operators Filter*/
        data: [],
        selectedData: {},
        onChange: null,
        currentpage: 0,
        max_num_pages: 0,
        isLoading:false,
        onPageChange:()=>{},
        multiple_posttype:false
    };


    _convertBMOS = (ar) => {
        let ardata = [];
        let partnerobj = [];    /*Separate Partners from Operators Filter*/

         //To store partners name data into array   /*Separate Partners from Operators Filter*/
         if(this.props.partners != null)
         {
             this.props.partners.map((partnersdata,partnersindex) =>{
                 const {post_name} = partnersdata
                 partnerobj.push(post_name.toLowerCase());
             });
          }
          //To store partners name data into array  /*Separate Partners from Operators Filter*/

        if (ar !== null) {
            ar.forEach(function (entry) {
                const name = entry.node.name;
                if(name.toLowerCase().startsWith('bridge') == false)  //To remove bridge from bmos  /*Separate Partners from Operators Filter*/
                {
                    ardata.push({
                        value: entry.node.termTaxonomyId, label: entry.node.name
                    });
                }   
            });
        }

          //To remove partners from bmos    /*Separate Partners from Operators Filter*/
          let ardata_partners_index =[];                    //code to remove partners from bmos array
         if(partnerobj.length >= 1)
         {
            
             ardata.map((data,index) => {
                 const {label} = data
                 
                 for (var i = 0; i < partnerobj.length; i++) {
                    
                     if(label.toLowerCase().startsWith(partnerobj[i]) == true)
                     {
                        //ardata.splice(index,1);           //code to remove partners from bmos array
                        ardata_partners_index.push(index);  //code to remove partners from bmos array
                        break;                              //code to remove partners from bmos array
                     }
                 }
             });
            
             //code to remove partners from bmos array
             for(var r=ardata_partners_index.length-1; r>=0; r--)
             {
                 ardata.splice(ardata_partners_index[r],1);
             }
             //code to remove partners index in bmos array

         }
         //To remove partners from bmos /*Separate Partners from Operators Filter*/

        return ardata;
    }

    /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
    _convertLBL = (ar) => {
        let ardata = [];
        if (ar !== null) {
            ar.forEach(function (entry) {
                ardata.push({
                    value: entry.node.termTaxonomyId, label: entry.node.name
                });
            });
        }
        return ardata;
    }
    /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 

    /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
    /*
    _convertIndustries = (ar) => {
        let ardata = [];
        if (ar !== null) {
            ar.forEach(function (entry) {
                ardata.push({
                    value: entry.node.termTaxonomyId, label: entry.node.name
                });
            });
        }
        return ardata;
    }
    */

    /*Separate Partners from Operators Filter*/

   _convertPartners = (ar) => {
    let ardata = [];
    if ((ar !== null) && (this.props.bmos_partners != null)) {
        ar.map( (partner,partnerindex) => {
            const {post_title} = partner
                this.props.bmos_partners.map( (bmos,bmosindex) => {
                    const {node} = bmos
                    if(post_title.toLowerCase() == node.name.toLowerCase())
                    {
                        ardata.push({value:node.termTaxonomyId,label:node.name});
                    }
                });
            });
    }
    return ardata;
    }

    _convertBridge = () => {
        let ardata = [];
        this.props.bmos_partners.map( (bmos_data,bmosindex) => {
            const {node} = bmos_data
            if(node.name.toLowerCase().startsWith('bridge'))
            {
                ardata.push({value:node.termTaxonomyId,label:node.name});
            }
        });
        return ardata;
    }

     /*Separate Partners from Operators Filter*/
   
   _convertMainIndustries = (ar) => {
    let ardata = [];
    if (ar !== null) {
        ar.forEach(function (entry) {
            //if(entry.node.name == 'Financial' || entry.node.name == 'Automotive' || entry.node.name == 'Transportation')
            if(entry.node.name == '5G' || entry.node.name == 'MEC' || entry.node.name == 'Cloud Gaming')
            {
                ardata.push({
                    value: entry.node.termTaxonomyId, label: entry.node.name
                });
            }
        });
    }
    return ardata;
    }

   _convertIndustries = (ar) => {
    let ardata = [];
    if (ar !== null) {
        ar.forEach(function (entry) {
           //if(entry.node.name != 'Financial'  && entry.node.name != 'Automotive' && entry.node.name !='Transportation')
           //commented for MainIndustry ddl //if(entry.node.name != '5G' && entry.node.name != 'MEC' && entry.node.name != 'Cloud Gaming')
            //{ //commented for MainIndustry ddl
                ardata.push({
                    value: entry.node.termTaxonomyId, label: entry.node.name
                });
           //} //commented for MainIndustry ddl
            
        });
    }
    return ardata;
    }   
    /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 

    _convertYears = () => {
        let ardata = [];
        let currentYear = new Date().getFullYear();
        let launchedYear = 2019;
        for (let i = launchedYear; i <= currentYear; i++) {
            ardata.push({ value: i, label: i });
        }

        return ardata;
    }
    _convertMonths = () => {
        let ardata = [];
        ardata.push({ value: 1, label: "January" });
        ardata.push({ value: 2, label: "February" });
        ardata.push({ value: 3, label: "March" });
        ardata.push({ value: 4, label: "April" });
        ardata.push({ value: 5, label: "May" });
        ardata.push({ value: 6, label: "June" });
        ardata.push({ value: 7, label: "July" });
        ardata.push({ value: 8, label: "August" });
        ardata.push({ value: 9, label: "September" });
        ardata.push({ value: 10, label: "October" });
        ardata.push({ value: 11, label: "November" });
        ardata.push({ value: 12, label: "December" });
        return ardata;
    }

    _getColSize = () => {
        let size = 6;
        let count = 0;
        if (this.props.bmos != null) {
            count++;
        } if (this.props.industries != null) {
            count++;
        } if (this.props.years != null) {
            count++;
        } if (this.props.months != null) {
            count++;
        }

        if (count === 3) {
            size = 4;
        } if (count === 4) {
            size = 3;
        }
        return size;
    }

    _convertArray = (data) => {
        let perslot = 4;
        let loop = (data.length / perslot);
        let ar = [];
        let start = 0;
        let end = ((data.length >= perslot) ? perslot : data.length);
        for (let i = 0; i < loop; i++) {
            ar.push(data.slice(start, end));
            start = end + 1;
            end = start + perslot;
            if (end > data.length) {
                end = data.length;
            }
        }
        return ar;
    }

    _checkFileType = (mimitype) => {
        let type = "";
        try {
            type = mimitype.split("/")[0];
        } catch (error) {
            type = "";
        }
        return type;
    }

    _convertToSelect2 = (ar) => {
        let ardata = [];
        ar.forEach(function (entry) {
            ardata.push({
                value: entry
            });
        });
        return ardata;
    }

    handleOnChange = (e, type) => {
        if (this.props.onChange !== null) {
            if (e !== null) {
                this.props.onChange((Array.isArray(e) ? e : [e]), type)
            } else {
                this.props.onChange([], type)
            }
        }
    }

    /*
    renderHeaderMedia = (item) => {
       
        if (item.headermedia) {
            const headermedia=_.isArray(item.headermedia)?item.headermedia:[item.headermedia];
            console.log(headermedia)
            const media = _.get(headermedia[0],`sizes.post-card-thumbnail`,"https://via.placeholder.com/450x210")
            const mediaurl = typeof media=== 'object' ? media.url : media
            return (
                <img src={mediaurl} alt="" className="card-img-top" />
            )
        }
        return (
            null
        )

    }
    */
    



    _onPageChange = (page) => {
        if(page>0 && this.props.max_num_pages>=page){
            this.props.onPageChange(page);
        }
    }

    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
    /*  
    _onClickBox = (posttype,slug)=>{
        let page=posttype==="post"?"resources":"offerings";
        if(posttype==="partner"){
            page="partners";
        }
        this.props.history.push(`/${page}/${slug}`);
    }
    */

    /*Videos Card_Image */
    
   renderHeaderMedia = (item,title,desc, card_title_desc) => {
       
    if (item.headermedia) {
        const headermedia=_.isArray(item.headermedia)?item.headermedia:[item.headermedia];        
        const media = _.get(headermedia[0],`sizes.post-card-thumbnail`,"https://via.placeholder.com/450x210")
        const mediaurl = typeof media=== 'object' ? media.url : media
        return (
            /*
            <div className="hover-card"  style={{backgroundImage:"url(" +mediaurl + ")",height:"240px",paddingTop:'10px',position:'relative'}}>
                <div className="bg-overlay" style={{position:"absolute",bottom:'8px',left:'16px'}}>
                    <h4>{title}</h4>
                    <p style={{visibility:"hidden"}}>{desc}</p>
                </div>
            </div>
            */

           /*Card-Img  - Hover Text display  */
           /*
           <div className="hover-card"  style={{backgroundImage:"url(" +mediaurl + ")",height:"240px",paddingTop:'10px',position:'relative'}}>
                <div className="content" style={{position:"absolute",bottom:'0px',left:'0px',background:"rgba(0, 0, 0, 0.5)",color:"#f1f1f1"}}>
                    <h4><p>{title}</p></h4>
                        <p>{desc}</p>
                </div>
            </div>
            */
            /*Card-Img  - Hover Text display  */

            /* Videos Page - Card display */
            <div className="news-textOverImage"  style={{backgroundImage:"url(" +mediaurl + ")"}}
            data-Text ={card_title_desc}>
            </div>
            /* Videos Page - Card display */
        )
    }
    return (
        null
    )
}


    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
    _onClickBox = async(bmo,posttype,slug)=>{
        let page=posttype==="post"?"resources":"offerings";
        if(posttype==="partner"){
            page="partners";
        }
        if(posttype==="videos"){
            //page="resources";
            page="videos";
        }
        let bmoname = bmo[0].name;
        let obj={};
        obj['userid']= localStorage['currentuserid'];
        //obj['message']= page +'-'+ bmoname +'-'+ slug ;
        obj['message']= page +'-'+ slug ;
		await userApi.setUserActivitylog(obj); 
        this.props.history.push(`/${page}/${slug}`);
    }
    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/

    getPostCard = item => {
        //let desc = item.post_excerpt.length > 225 ? item.post_excerpt.substr(0,224)+" ..." : item.post_excerpt;
        //const title_resources = item.post_title.length > 48 ? item.post_title.substr(0,48)+"..." : item.post_title;
        let title = item.post_title.length > 45 ? item.post_title.substr(0,44)+"..." : item.post_title;
        let desc = item.post_excerpt.length > 50 ? item.post_excerpt.substr(0,49)+" ..." : item.post_excerpt;

        

        {/*Cards Uploaded time display*/}
        const uploadeddate = item.post_modified.length > 0 ? new Date(item.post_modified) : new Date(item.post_date);
        //const uploadeddate = item.post_date.length > 0 ? new Date(item.post_date) : new Date(item.post_modified);
        //const uploadedPostdate = item.post_date;
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const uploadedFormattedDate = monthNames[uploadeddate.getMonth()] + "-" + uploadeddate.getFullYear();
        const uploadedVideosDate = uploadeddate.getDate() + "-" + monthNames[uploadeddate.getMonth()] + "-" + uploadeddate.getFullYear();
        {/*Cards Uploaded time display*/}

        //const card_title_desc = title.toUpperCase() + '\n\n'+ uploadedVideosDate + '\n\n' + desc + '\n\n'
        let card_title_desc =  title  + '\n\n' + desc + '\n\n' + uploadedVideosDate + '\n\n'
        /*Videos Card_Image */
        
        return (
            <Card onClick={()=>this._onClickBox(item.bmos,item.post_type,(item.post_name!==""?item.post_name:item.ID ))} className="post-card mb-4 w3-card-4 Cursor-pointer" key={item.post_name}> 
                <Card.Body> 
                  <div style={{height:'240px'}}>
                  
                    <Card.Text>
                        {this.renderHeaderMedia(item,title,desc, card_title_desc)}

                        {(item.post_status==="pending") && (
                            <Badge variant="light">{`Pending`}</Badge>
                        )}
                        {(item.post_status==="future") && (
                            <Badge variant="secondary">{`Future`}</Badge>
                        )}
                        
                    </Card.Text>
                    </div>
                </Card.Body>
            </Card>
        )
        
       /*Videos Card_Image */

        {/*Comments: Card style-Zoom,spacing, UserActivityLog by CardClick, Added By: <Asar>, Create Date: <2020-02-18>*/}
        /*
        return (
            <Card onClick={()=>this._onClickBox(item.bmos,item.post_type,(item.post_name!==""?item.post_name:item.ID ))} className="post-card mb-4 w3-card-4 w3-padding-card zoom Cursor-pointer" key={item.post_name}> 
                <Card.Body className="w3-container"> 
                    {(this.props.multiple_posttype) && (
                        <div style={{height:'50px'}}><Card.Title className="w3-textpadding-card w3-card-title-fontsize">{`${title} `}<Badge variant="dark">{item.post_type==="post"?" resource":` ${item.post_type}`}</Badge></Card.Title></div>
                    )}
                    {(this.props.multiple_posttype===false) && (
                        <div style={{height:'50px'}}><Card.Title className="w3-textpadding-card w3-card-title-fontsize">{title}</Card.Title></div>  
                    )}
                  
                  <div style={{height:'160px'}}>
                  <div>{this.renderHeaderMedia(item)}</div>
                    <Card.Text className="w3-textpadding-card">
                    
                        {(item.post_status==="pending") && (
                            <Badge variant="light">{`Pending`}</Badge>
                        )}
                        {(item.post_status==="future") && (
                            <Badge variant="secondary">{`Future`}</Badge>
                        )}
                        <span className="text-muted">{desc}</span>  
                    </Card.Text>
                    </div>


                    <div style={{height:'30px'}}>
                        <Card.Text className="w3-textpadding-card">
                            {
                                item.post_type === 'offering' &&
                                <React.Fragment>
                                    { 
                                        item.bmos.map( bmo => {
                                            return (
                                                <b key={bmo.name}>{bmo.name} </b>
                                            )
                                        })
                                    }
                                    <span className="text-muted"> | </span>
                                    { item.post_type === 'offering' &&
                                        item.industry.map( ind => {
                                            return (
                                                <span key={ind.name}>{_.unescape(ind.name)} </span>
                                            )
                                        })
                                    }
                                </React.Fragment>
                            }
                            <br/>
                            
                        </Card.Text>
                    </div>
                    <Card.Text className="w3-textpadding-card">
                        <b>Uploaded On:</b> {uploadedFormattedDate} 
                    </Card.Text>
                    <Card.Text ><br/></Card.Text>
                </Card.Body>
            </Card>
        )
       */
    }

    printItems = items => {
        let res = [];
        for (let i=0; i < items.length; i+=4){
            const cards = _.range(i,i+4,1)
            res.push(
                <Row key={i}>
                    {
                        cards
                            .filter( card => !!items[card] )
                            .map( card => {
                            //if (items[card]){
                                return (
                                    <Col key={card} xs={6} md={3}>
                                        {this.getPostCard(items[card])}
                                    </Col>
                                )
                            //}
                        })
                    }
                </Row>
            )
        }
        return res
    }

    getPagingRange = (current, {min = 1, total = 20, length = 5} = {}) => {
        if (length > total) length = total;
      
        let start = current - Math.floor(length / 2);
        start = Math.max(start, min);
        start = Math.min(start, min + total - length);
       
        return Array.from({length: length}, (el, i) => start + i);
    }

    render = () => {
        let colsize = this._getColSize();
        const data = this.props.data
        let selectedBMOS = ((this.props.selectedData.selected_bmos !== null && this.props.selectedData.selected_bmos !== undefined) ? this.props.selectedData.selected_bmos : []);
        let selectedLbls = ((this.props.selectedData.selected_industries !== null && this.props.selectedData.selected_industries !== undefined) ? this.props.selectedData.selected_industries : []); /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/
        let selectedPartners = ((this.props.selectedData.selected_partners !== null && this.props.selectedData.selected_partners !== undefined) ? this.props.selectedData.selected_partners : []);   //added for partners   /*Separate Partners from Operators Filter*/
        let selectedBridge = ((this.props.selectedData.selected_bridge !== null && this.props.selectedData.selected_bridge !== undefined) ? this.props.selectedData.selected_bridge : []);           //added for Bridge     /*Separate Partners from Operators Filter*/
        let selectedIndustries = ((this.props.selectedData.selected_industries !== null && this.props.selectedData.selected_industries !== undefined) ? this.props.selectedData.selected_industries : []);
        let selectedYears = ((this.props.selectedData.selected_years !== null && this.props.selectedData.selected_years !== undefined) ? this.props.selectedData.selected_years : []);
        let selectedMonths = ((this.props.selectedData.selected_months !== null && this.props.selectedData.selected_months !== undefined) ? this.props.selectedData.selected_months : []);

        let arbmos = this._convertBMOS(this.props.bmos);
        let arlbls = this._convertLBL(this.props.lbls);  /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
        let arpartners = this._convertPartners(this.props.partners);    //added for partners    /*Separate Partners from Operators Filter*/
        let arbridge = this._convertBridge();//added for bridge /*Separate Partners from Operators Filter*/
        let arindustries = this._convertIndustries(this.props.industries);
        let arMainindustries = this._convertMainIndustries(this.props.industries); /*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ 
        let aryears = this._convertYears();
        let armonths = this._convertMonths();


        let curpage = this.props.currentpage;
        let totalpages = this.props.max_num_pages;

        const paginateLinks = this.getPagingRange(1,{min:1,total:totalpages,length:10})


        return (
            <React.Fragment>
                <div className="row">

                    {/*
                    {(this.props.bmos !== null) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Operators</label>
                                <Select isMulti options={arbmos}
                                    value={arbmos.filter(f => selectedBMOS.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "bmos")}
                                />
                            </div>
                        </div>
                    )}
                    */}

                    {/*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ }
                    {/*
                    {(this.props.lbls == null) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By LBL</label>
                                <Select isMulti options={arlbls}
                                    value={arlbls.filter(f => selectedLbls.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "lbls")}
                                />
                            </div>
                        </div>
                    )}
                    */}

                    {/* Commented for Remove Technology dropdown
                    {(this.props.industries !== null) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Technology</label>
                                <Select isMulti options={arMainindustries}
                                    value={arMainindustries.filter(f => selectedIndustries.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "industries")}
                                />
                            </div>
                        </div>
                    )}
                    */}

                    {/*Comments: new Dropdown, Added By: <Asar>, Create Date: <2020-02-06>*/ }

                    {/*Separate Partners from Operators Filter*/}
                    {/*
                    {(this.props.bmos !== null) && (this.props.partners_enable != false) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Industry Player</label>
                                <Select isMulti options={arpartners}
                                    value={arpartners.filter(f => selectedPartners.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "partners")}
                                />
                            </div>
                        </div>
                    )}
                    
                     {(this.props.bmos !== null)  && (this.props.bridge_enable != false)  && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Bridge Alliance</label>
                                <Select isMulti options={arbridge}
                                    value={arbridge.filter(f => selectedBridge.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "bridge")}
                                />
                            </div>
                        </div>
                    )}
                     */}
                    {/*Separate Partners from Operators Filter*/}
                  
                  {/*
                    {(this.props.industries !== null) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Industry</label>
                                <Select isMulti options={arindustries}
                                    value={arindustries.filter(f => selectedIndustries.includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "industries")}
                                />
                            </div>
                        </div>
                    )}
                        
                    {(this.props.years !== false) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                            <div className="form-group">
                                <label >Filter By Year</label>
                                <Select options={aryears}
                                    value={aryears.filter(f => [selectedYears].includes(f.value))}
                                    onChange={(e) => this.handleOnChange(e, "year")}
                                    isClearable
                                />
                            </div>
                        </div>
                    )}
                    {(this.props.months !== false) && (
                        <div className={`col-sm-12 col-md-${colsize}`}>
                              <div className="form-group">
                                <label >Filter By Month</label>
                            <Select options={armonths}
                                value={armonths.filter(f => [selectedMonths].includes(f.value))}
                                onChange={(e) => this.handleOnChange(e, "month")}
                                isClearable
                            />
                            </div>
                        </div>
                    )}
                    */}
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {this.props.isLoading && (
                            <div className="text-center p-5">
                                <div className="spinner-border text-secondary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        )}
                        {
                            this.printItems(data)
                        }
                        <br/><br/><br/><br/><br/><br/><br/><br/><br/>
                        {/* {this.props.isLoading===false && data.map((value, index) => {
                            return (
                                <div className="row">
                                    {value.map((v, i) => (
                                        <div className="col-md-3 mb-4">
                                            <div className="card post-card" >
                                                {this.renderHeaderMedia(v.headermedia)}
                                                <div className="card-body">
                                                    <h5 className="card-title">{v.post_title}</h5>
                                                    <p className="card-text">{v.post_excerpt}</p>
                                                    <a href={`${this.props.posttype}/${(v.post_name===""?v.ID:v.post_name)}`} className={`${v.post_status==="pending"?"btn btn-outline-primary":"btn btn-primary"}`}>Learn More</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        })} */}

                        {/*
                        <Row>
                            {(totalpages > 1) && (
                                <Col>
                                    <Pagination className="flex-center">
                                    <Pagination.First disabled={curpage==1} onClick={()=>this._onPageChange(1)}  />
                                    <Pagination.Prev disabled={curpage==1} onClick={()=>this._onPageChange(curpage-1)}/>
                                    
                                    {
                                        paginateLinks.map( link => {
                                            return <Pagination.Item key={link} active={link==curpage} onClick={()=>this._onPageChange(link)}>{link}</Pagination.Item>
                                        })
                                    }
                                    <Pagination.Next disabled={curpage==totalpages} onClick={()=>this._onPageChange(curpage+1)} />
                                    <Pagination.Last disabled={curpage==totalpages} onClick={()=>this._onPageChange(totalpages)} />
                                    </Pagination>
                              </Col>
                            )}
                        </Row>
                        */}

                    </div>
                </div>
            </React.Fragment>
        );
    }

}


/* Export Component ==================================================================== */
export default withRouter(VideosGridContainer);